__turbopack_context__.v({
  "button": "RadioWidget-module-scss-module__lDPViW__button",
  "container": "RadioWidget-module-scss-module__lDPViW__container",
  "radioTitle": "RadioWidget-module-scss-module__lDPViW__radioTitle",
  "right": "RadioWidget-module-scss-module__lDPViW__right",
  "text": "RadioWidget-module-scss-module__lDPViW__text",
  "textLeftContent": "RadioWidget-module-scss-module__lDPViW__textLeftContent",
  "wrapper": "RadioWidget-module-scss-module__lDPViW__wrapper",
});
